// Avoid dependency import cycles
import { useAuthStore } from '../../store/use-auth-store';
import { ApiError } from '../model';

export const errorInterceptorHandler = (error: ApiError<unknown>) => {
  const { setIsAuthenticated, setShowUnauthenticatedToast } = useAuthStore.getState();

  const status = error?.response?.status;

  if (status && [401, 403].includes(status)) {
    setShowUnauthenticatedToast(true);
    setIsAuthenticated(false);

    return Promise.reject(new Error(`Request failed with status ${status}`));
  }

  return Promise.reject(
    new Error(`Network or other error when requesting ${error?.config?.url}:`, error),
  );
};
